import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const postmark = defineConnector({
  identifier: "postmark",
  name: "Postmark",
  tagLine: "Transactional email delivery",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://api\\.postmarkapp\\.com/.*",
  auth: (app) =>
    headerAuth([
      { name: "X-Postmark-Server-Token", value: app.secret.serverToken },
    ]),
  steps: [
    {
      title: "Get your server API token",
      items: [
        {
          kind: "markdown",
          content:
            "In [Postmark](https://account.postmarkapp.com/), open your server and copy a token from the **API Tokens** tab.",
        },
      ],
    },
    {
      title: "Paste your server API token",
      items: [
        {
          kind: "input",
          label: "Server API token",
          required: true,
          target: { kind: "secrets", field: "serverToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.postmarkapp.com/server",
  },
});
